// A blank Services form. Used for first render, "Add Service" and after closing the dialog, so
// they can't drift apart (a missing showOnMenu made every new service save as hidden from the menu).
export const emptyServiceForm = () => ({
  title: "",
  slug: "",
  shortDescription: "",
  fullDescription: "",
  features: "",
  technologies: "",
  benefits: "",
  icon: "",
  image: "",
  order: 0,
  featured: false,
  showOnMenu: true,
});

// Text for the table's description column: the saved short description (rich text) without markup.
export function descriptionPreview(service, max = 60) {
  const text = String(service.shortDescription || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&amp;/g, "&") // last, so "&amp;lt;" stays "&lt;"
    .replace(/\s+/g, " ")
    .trim();
  if (!text) return "-";
  return text.length > max ? `${text.substring(0, max)}...` : text;
}
